import React, { Fragment } from "react";

import { Helmet } from "react-helmet";

import NavigationBarGeneral from "../components/navigation-bar-general";
import Footer from "../components/footer";
import "./blog.css";

const Blog = (props) => {
  return (
    <div className="blog-container">
      <Helmet>
        <title>Blog | CashOver Pay</title>
        <meta
          name="description"
          content="Explore the CashOver blog for the latest updates, projects, and stories from our team."
        />
        <meta property="og:title" content="Blog | CashOver" />
        <meta
          property="og:description"
          content="Read our latest endeavors, works and office adventures at CashOver."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/icon.webp`}
        />
      </Helmet>
      <NavigationBarGeneral
        text={
          <Fragment>
            <span className="blog-text1">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="blog-text2">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-generalroot-class-name2"
      ></NavigationBarGeneral>
      <div className="blog-column1">
        <div className="blog-column2">
          <h1 className="blog-text3">
            <span>
              CASHOVER
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </span>
            <span className="blog-text5">BLOG</span>
          </h1>
          <p className="blog-text6">
            Read our latest endeavors, works and office adventures!
          </p>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name"></Footer>
    </div>
  );
};

export default Blog;
